(function () {
  const STORAGE_KEY = 'electricblue_wishlist';
  const CACHE_KEY = 'electricblue_wishlist_products';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    updateButtons();
    updateCounter();
  }

  function getProductCache() {
    try {
      return JSON.parse(localStorage.getItem(CACHE_KEY)) || {};
    } catch (e) {
      return {};
    }
  }

  function saveProductToCache(handle, product) {
    const cache = getProductCache();

    cache[handle] = {
      title: product.title,
      url: product.url,
      price: product.price,
      featured_image: product.featured_image,
      cached_at: Date.now()
    };

    localStorage.setItem(CACHE_KEY, JSON.stringify(cache));
  }

  function removeProductFromCache(handle) {
    const cache = getProductCache();

    if (cache[handle]) {
      delete cache[handle];
      localStorage.setItem(CACHE_KEY, JSON.stringify(cache));
    }
  }

  function isInWishlist(handle) {
    return getWishlist().includes(handle);
  }

  function addToWishlist(handle) {
    const items = getWishlist();

    if (!items.includes(handle)) {
      items.push(handle);
      saveWishlist(items);
    }
  }

  function removeFromWishlist(handle) {
    const items = getWishlist().filter(function (item) {
      return item !== handle;
    });

    saveWishlist(items);
    removeProductFromCache(handle);
  }

  function toggleWishlist(handle) {
    if (isInWishlist(handle)) {
      removeFromWishlist(handle);
    } else {
      addToWishlist(handle);
    }
  }

  function getProductUrl(handle) {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

    return root + 'products/' + handle + '.js';
  }

  function formatPrice(price) {
    if (!price) return '';

    const currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
      ? window.Shopify.currency.active
      : 'UAH';

    return (price / 100).toLocaleString('uk-UA', {
      style: 'currency',
      currency: currency
    });
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function renderProductCard(handle, product) {
    const title = escapeHtml(product.title);
    const url = product.url || '#';
    const price = formatPrice(product.price);
    const image = product.featured_image || '';

    return `
      <div class="wishlist-card" data-wishlist-item="${escapeHtml(handle)}">
        <a class="wishlist-card__image-link" href="${url}">
          ${
            image
              ? `<img class="wishlist-card__image" src="${image}" alt="${title}" loading="lazy">`
              : `<div class="wishlist-card__placeholder"></div>`
          }
        </a>

        <div class="wishlist-card__info">
          <a class="wishlist-card__title" href="${url}">
            ${title}
          </a>

          <div class="wishlist-card__price">
            ${price}
          </div>

          <div class="wishlist-card__actions">
            <a class="button button--primary button--small" href="${url}">
              Переглянути
            </a>

            <button class="wishlist-card__remove" type="button" data-wishlist-remove="${escapeHtml(handle)}">
              Видалити
            </button>
          </div>
        </div>
      </div>
    `;
  }

  function updateButtons() {
    document.querySelectorAll('[data-wishlist-button]').forEach(function (button) {
      const handle = button.getAttribute('data-product-handle');
      const active = isInWishlist(handle);

      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');

      const text = button.querySelector('[data-wishlist-text]');
      if (text) {
        text.textContent = active ? 'У списку бажань' : 'До списку бажань';
      }
    });
  }

  function updateCounter() {
  const count = getWishlist().length;

  document.querySelectorAll('[data-wishlist-count]').forEach(function (counter) {
    counter.textContent = count;
    counter.style.display = count > 0 ? 'inline' : 'none';
  });
}

  function initWishlistButtons() {
    document.addEventListener('click', function (event) {
      const button = event.target.closest('[data-wishlist-button]');

      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      const handle = button.getAttribute('data-product-handle');

      if (!handle) return;

      toggleWishlist(handle);
    });

    updateButtons();
    updateCounter();
  }

  async function loadProduct(handle) {
    const response = await fetch(getProductUrl(handle));

    if (!response.ok) return null;

    const product = await response.json();

    saveProductToCache(handle, product);

    return product;
  }

  async function renderWishlistPage() {
    const container = document.querySelector('[data-wishlist-grid]');
    const empty = document.querySelector('[data-wishlist-empty]');

    if (!container) return;

    const handles = getWishlist();

    if (!handles.length) {
      container.innerHTML = '';
      if (empty) empty.style.display = 'block';
      return;
    }

    if (empty) empty.style.display = 'none';

    const cache = getProductCache();

    const cachedHtml = handles
      .filter(function (handle) {
        return cache[handle];
      })
      .map(function (handle) {
        return renderProductCard(handle, cache[handle]);
      })
      .join('');

    if (cachedHtml) {
      container.innerHTML = cachedHtml;
    } else {
      container.classList.add('is-loading');
      container.innerHTML = '';
    }

    const productRequests = handles.map(function (handle) {
      return loadProduct(handle)
        .then(function (product) {
          if (!product) return null;

          return {
            handle: handle,
            product: product
          };
        })
        .catch(function () {
          return null;
        });
    });

    const results = await Promise.all(productRequests);

    const freshHtml = results
      .filter(Boolean)
      .map(function (item) {
        return renderProductCard(item.handle, item.product);
      })
      .join('');

    container.classList.remove('is-loading');

    if (freshHtml) {
      container.innerHTML = freshHtml;
      if (empty) empty.style.display = 'none';
    } else {
      container.innerHTML = '';
      if (empty) empty.style.display = 'block';
    }
  }

  function initWishlistPageRemove() {
    document.addEventListener('click', function (event) {
      const button = event.target.closest('[data-wishlist-remove]');

      if (!button) return;

      const handle = button.getAttribute('data-wishlist-remove');

      removeFromWishlist(handle);

      const card = document.querySelector('[data-wishlist-item="' + handle + '"]');
      if (card) card.remove();

      const container = document.querySelector('[data-wishlist-grid]');
      const empty = document.querySelector('[data-wishlist-empty]');

      if (container && !container.querySelector('[data-wishlist-item]')) {
        if (empty) empty.style.display = 'block';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initWishlistButtons();
    initWishlistPageRemove();
    renderWishlistPage();
  });

  document.addEventListener('shopify:section:load', function () {
    updateButtons();
    updateCounter();
    renderWishlistPage();
  });
})();